import React from "react";
import { FiEyeOff, FiXCircle } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { HashLink } from "react-router-hash-link";

export const About = () => {
  const { t } = useTranslation();
  return (
    <section id="about" className="w-full py-16 scroll-mt-24 bg-canvas sm:py-24">
      <div className="grid gap-10 px-4 mx-auto max-w-7xl sm:px-6 lg:grid-cols-12 lg:gap-16 lg:px-8">
        <div className="lg:col-span-7">
          <p className="zs-eyebrow">About</p>
          <h1 data-testid="about_title" className="mt-1 text-3xl font-bold tracking-tight font-display text-ink sm:text-4xl">
            {t("home.about.title")}
          </h1>
          <div className="max-w-[68ch] mt-6 space-y-5 text-base leading-relaxed text-ink-2">
            <p>{t("home.about.ZampliaSurveys")}</p>
            <p>{t("home.about.Surveyswasestablished")}</p>
            <p>{t("home.about.ZampliaSurveymembers")}</p>
            <p>{t("home.about.Thereisnocost")}</p>
          </div>
        </div>

        <div className="space-y-4 lg:col-span-5 lg:pt-10">
          <div className="p-6 zs-card">
            <span className="zs-stat-icon">
              <FiXCircle aria-hidden="true" />
            </span>
            <p className="mt-4 text-sm leading-relaxed text-ink-2">{t("home.about.Wearefully")}</p>
          </div>
          <div className="p-6 zs-card">
            <span className="zs-stat-icon">
              <FiEyeOff aria-hidden="true" />
            </span>
            <p className="mt-4 text-sm leading-relaxed text-ink-2">
              {t("home.about.Theanswers")}{" "}
              <HashLink smooth data-testid="privacyLink" to={"/privacy-policy/#privacy-policy"} className="zs-link">
                {t("home.about.privacypolicy")}
              </HashLink>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
